import { randomUUID } from 'expo-crypto';
import { useCartLiveValidationActions } from 'features/cart/hooks/use-cart-live-validation-actions';
import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';
import { ICartEntry, MinimalCartEntryType } from 'features/cart/types';
import { Icon } from 'ucl/components/icon/Icon';

import { t } from 'state/intl/translations';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';

import { CartEntryActionButton } from './cart-entry-action-button';

/* this uses maxCartQuantityMet */
export const CartEntryDuplicateButton = ({
  cartEntry,
  disabled,
  quantityOnCart,
}: {
  cartEntry: ICartEntry;
  disabled?: boolean;
  quantityOnCart?: number;
}) => {
  const { indexedMenu } = useUnifiedMenuContext();
  const { addItemToMinimalCart } = useMinimalCart();
  const { requestCartValidation } = useCartLiveValidationActions();
  const menuEntry = indexedMenu.find(cartEntry.id);
  const maxCartQuantity = menuEntry?.quantity?.max;

  // TODO modify it  for oneMenu
  // const attributes = {
  //   'Product Id': cartEntry.id,
  //   'Product Name': cartEntry.name,
  //   'Edit Url': productWizardEditUrl,
  //   'Is Reorder': booleanToString(false),
  //   'Is Offer': booleanToString(isOfferCartEntry(cartEntry)),
  // };
  // logRBIProductsDetailsEvent({
  //   name: CustomEventNames.EDIT_CART,
  //   products: [cartEntry as ICartEntryLoggable],
  //   attributes,
  // });

  const handleDuplicate = () => {
    const newCartEntry = {
      ...cartEntry,
      cartId: randomUUID(),
    };
    addItemToMinimalCart(newCartEntry);
    requestCartValidation();
  };

  if (cartEntry.type === MinimalCartEntryType.incentive) {
    return null;
  }
  if (
    cartEntry.type === MinimalCartEntryType.reward &&
    cartEntry.children?.[0]?.type === MinimalCartEntryType.combo
  ) {
    return null;
  }
  return (
    <CartEntryActionButton
      disabled={disabled || quantityOnCart >= maxCartQuantity}
      accessibilityLabel={`${t('duplicate')} ${cartEntry.name} `}
      testID="duplicate-cart-entry-button"
      icon={<Icon name="custom:DuplicateItem" size="md" />}
      onPress={handleDuplicate}
    />
  );
};
